export default __webpack_public_path__ + "static/media/ic_left_caret.7b9008b5.svg";